import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Container, Text, Stack, Paper, Table, Loader } from '@mantine/core'
import { ResponsiveTitle } from '../../components/ResponsiveTitle/ResponsiveTitle'
import { isAdminAuthenticated, refreshAdminSession } from '../../lib/auth'
import { AdminNavbar } from '../../components/AdminNavbar/AdminNavbar'
import { useGuests } from '../../hooks/useGuests'
import styles from './kartenliebe-daten.module.css'

export const Route = createFileRoute('/admin/kartenliebe-daten')({
  component: KartenliebeDaten,
})

function KartenliebeDaten() {
  const navigate = useNavigate()
  const { guests, loading } = useGuests()

  useEffect(() => {
    // Check if admin is authenticated
    if (!isAdminAuthenticated()) {
      navigate({ to: '/admin/login' })
      return
    }

    // Refresh session on page load
    refreshAdminSession()

    // Set up interval to check session expiration
    const interval = setInterval(() => {
      if (!isAdminAuthenticated()) {
        navigate({ to: '/admin/login' })
      }
    }, 60000) // Check every minute

    return () => clearInterval(interval)
  }, [navigate])

  // Prepare data for display (same format as export)
  const tableData = guests.map((guest) => {
    // Find plus_one in additional_guests
    let plusOneName = ''
    if (guest.additional_guests && guest.additional_guests.length > 0) {
      const plusOne = guest.additional_guests.find((ag) => ag.type === 'plus_one')
      if (plusOne) {
        plusOneName = plusOne.name || ''
      }
    }

    // Format text column: if no +1, just the name; if +1 exists, format with newlines
    let text1: string
    if (plusOneName) {
      text1 = `${guest.primary_name || ''}\n&\n${plusOneName}`
    } else {
      text1 = guest.primary_name || ''
    }

    return {
      text1,
      text2: guest.pin || '',
    }
  })

  if (loading) {
    return (
      <div className={styles.adminLayout}>
        <AdminNavbar />
        <Container size="xl" py="xl">
          <Stack align="center" gap="md">
            <Loader size="lg" />
            <Text c="dimmed">Lädt...</Text>
          </Stack>
        </Container>
      </div>
    )
  }

  return (
    <div className={styles.adminLayout}>
      <AdminNavbar />
      <Container size="xl" py="xl">
        <Stack gap="xl">
          <ResponsiveTitle order={1}>Kartenliebe Daten</ResponsiveTitle>
          <Text size="lg" c="dimmed">
            Übersicht der Daten für den Kartenliebe-Export
          </Text>

          <Paper shadow="sm" p="md">
            <Table striped highlightOnHover>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Text 1</Table.Th>
                  <Table.Th>Text 2</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {tableData.map((row, index) => (
                  <Table.Tr key={index}>
                    <Table.Td style={{ whiteSpace: 'pre-line' }}>{row.text1}</Table.Td>
                    <Table.Td>{row.text2}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </Paper>
        </Stack>
      </Container>
    </div>
  )
}

